import { render } from "./AccordionElement.vue?vue&type=template&id=07d24672&scoped=true&ts=true&lang=pug"
import script from "./AccordionElement.vue?vue&type=script&lang=ts"
export * from "./AccordionElement.vue?vue&type=script&lang=ts"

import "./AccordionElement.vue?vue&type=style&index=0&id=07d24672&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d24672"]])

export default __exports__